<div class="container">
  <h1 class="page-title"
    [helpCenterButton]="helpPermissionCode" [lang]="currentLang"
    [helpCenterDownloadButton]="helpPermissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon"><i class="fas fa-scroll"></i></span>{{ 'MaterialSearch.Header' | translate }}</h1>
  <p-card>
    <p-accordion>
      <p-accordionTab header="{{ 'Common.Form.Header' | translate }}" [selected]="isSearchFormOpen">
        <form [formGroup]="searchForm">
          <div class="p-fluid formgrid grid">
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'MaterialSearch.Search.LaasDoNumber' | translate }}</label>
              <p-chips formControlName="laasDoNumber" separator="," (onAdd)="chipsAdd($event, 'laasDoNumber')"></p-chips>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'MaterialSearch.Search.Plant' | translate }}</label>
              <laas-plant-dropdown
                [isSingle]="true"
                formControlName="plant">
              </laas-plant-dropdown>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'MaterialSearch.Search.MaterialDocumentYear' | translate }}</label>
              <input pInputText type="number" formControlName="materialDocumentYear">
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'MaterialSearch.Search.MaterialDocumentNumber' | translate }}</label>
              <p-chips formControlName="materialDocumentNumber" separator="," (onAdd)="chipsAdd($event, 'materialDocumentNumber')"></p-chips>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'MaterialSearch.Search.TransactionDate' | translate }}</label>
              <input pInputText type="text" formControlName="transactionDate">
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'MaterialSearch.Search.TransactionTime' | translate }}</label>
              <input pInputText type="text" formControlName="transactionTime">
            </div>
            <div class="col-12 md:col-6 lg:col-4 laas-calendar">
              <laas-calendar
                #createDt
                [title]="'MaterialSearch.Search.CreateDt'"
                [enableMaxDateIsToday]="false"
                [showRangeMode]="true"
                [showStartMode]="true"
                (onDateChange)="dateOnChange($event, 'createDt')">
              </laas-calendar>
            </div>
          </div>
          <div class="grid">
            <div class="col">
              <button pButton pRipple label="{{ 'Common.Button.Search' | translate }}" (click)="searchClickBtn()"></button>
              <button pButton pRipple label="{{ 'Common.Button.Reset' | translate }}" (click)="resetClickBtn()" class="p-button-secondary ml-2"></button>
            </div>
          </div>
        </form>
      </p-accordionTab>
    </p-accordion>

    <div class="mt-2">
      <laas-data-table
        #dataTable
        [value]="searchResults"
        [defaultColumns]="tableColumns"
        [loading]="isLoading"
        [lazy]="true"
        [rows]="pageInfo.pageSize"
        [totalRecords]="pageInfo.totalRecords"
        (tableOnPage)="tablePageChange($event)"
        (tableOnSort)="tableSort($event)">
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <td *ngFor="let col of columns">
            <ng-container [ngSwitch]="col.field">
              <ng-container>
                <ng-container *ngSwitchCase="'createDt'">
                  <div class="overflow-text">
                    {{ rowData[col.field] | date: "yyyy-MM-dd":this.laasSetting.facilityTimeZone | replaceNullWith: "-" }}
                  </div>
                </ng-container>
                <ng-container *ngSwitchDefault>
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith: '-'}}
                  </div>
                </ng-container>

              </ng-container>
            </ng-container>
          </td>
        </ng-template>
      </laas-data-table>
    </div>
  </p-card>
</div>
<help-dock
  [permissionCode]="helpPermissionCode"
  [lang]="currentLang">
</help-dock>
